import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { INFO_SECTIONS_SERVICES } from '../data';

// Importar imágenes
import cuidadorasImg from '../assets/cuidadoras.jpg';
import auxiliarImg from '../assets/auxiliar.jpg';
import enfermeriaImg from '../assets/general.jpg';
import suerosImg from '../assets/suero.jpg';

// Mapeo de nombres a imágenes
const imageMap = {
  cuidadoras: cuidadorasImg,
  auxiliar: auxiliarImg,
  enfermeria: enfermeriaImg,
  sueros: suerosImg
};

const ServiceSection = ({
  title,
  description,
  image,
  alt,
  sectionId,
  reverse = false
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/services#${sectionId}`, {
      state: { scrollTo: sectionId },
      replace: true
    });
  };

  // Obtener la imagen del mapa o usar directamente si es una URL
  const imageSrc = imageMap[image] || image;

  return (
    <section
      className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} 
      items-stretch gap-8 my-12 lg:my-16`}
    >
      <div className="w-full md:w-1/2 relative group overflow-hidden rounded-2xl shadow-xl">
        <img
          src={imageSrc}
          alt={alt}
          className="w-full h-80 md:h-[500px] object-cover transform transition-transform 
          duration-500 group-hover:scale-105"
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className={`w-full md:w-1/2 flex items-center p-4 md:p-8 ${reverse ? 'md:pr-12' : 'md:pl-12'}`}>
        <div className="space-y-6 max-w-2xl">
          <h2 className="text-4xl font-bold text-gray-800">{title}</h2>
          <p className="text-lg text-gray-600 leading-relaxed">{description}</p>
          <button
            onClick={handleNavigate}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold
            hover:bg-blue-700 transition-colors duration-300 flex items-center gap-2"
            aria-label={`Más información sobre ${title}`}
          >
            <span>Conócenos más</span>
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

ServiceSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  reverse: PropTypes.bool
};

function InfoSections() {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      {INFO_SECTIONS_SERVICES.map((service, index) => (
        <ServiceSection
          key={service.sectionId}
          {...service}
          reverse={index % 2 !== 0}
        />
      ))}
    </div>
  );
}

export default InfoSections;
